
import React, { useState } from 'react';
import { Container, Box } from '@mui/material';
import { Routes, Route, useNavigate } from 'react-router-dom';

import StepContentContainer from '../../components/StepContentContainer';
import Header from '../../components/Header';
import StepperNav from '../../components/StepperNav';
import StartPage from './StartPage';
import ScanFrontPage from './ScanFrontPage';
import ScanBackPage from './ScanBackPage';
import CheckPage from './CheckPage';
import BillingPage from './BillingPage';

export default function ScannerPage() {
    const [activeStep, setActiveStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState(-1);
    const [frontImage, setFrontImage] = useState(null);
    const [backImage, setBackImage] = useState(null);

    const handleStepClick = (stepIndex) => {
        if (stepIndex <= completedSteps) {
            setActiveStep(stepIndex + 1);
        }
    };

    const goToNextStep = () => {
        const newStep = activeStep + 1;
        if (newStep > completedSteps) {
            setCompletedSteps(newStep - 1);
        }
        setActiveStep(newStep);
    };

    const goToPrevStep = () => {
        const newStep = activeStep - 1;
        setActiveStep(newStep < 0 ? 0 : newStep);
    };


    let content;
    switch (activeStep) {
        case 0:
            content = <StartPage onStart={() => setActiveStep(1)} />;
            break;
        case 1:
            content = (
                <StepContentContainer>
                    <ScanFrontPage frontImage={frontImage} setFrontImage={setFrontImage} onNext={goToNextStep} />
                </StepContentContainer>
            );
            break;
        case 2:
            content = (
                <StepContentContainer>
                    <ScanBackPage backImage={backImage} setBackImage={setBackImage} onNext={goToNextStep} onPrev={goToPrevStep} />
                </StepContentContainer>
            );
            break;
        case 3:
            content = (
                <StepContentContainer>
                    <CheckPage
                        frontImage={frontImage}
                        backImage={backImage}
                        onNext={goToNextStep}
                        onRestart={() => {
                            setFrontImage(null);
                            setBackImage(null);
                            setCompletedSteps(-1);
                            setActiveStep(1);
                        }}
                    />
                </StepContentContainer>
            );
            break;
        case 4:
            content = (
                <StepContentContainer>
                    <BillingPage
                        onFinish={() => {
                            setFrontImage(null);
                            setBackImage(null);
                            setCompletedSteps(-1);
                            setActiveStep(0);
                        }}
                    />
                </StepContentContainer>
            );
            break;
        default:
            content = <div>Unbekannter Schritt</div>;
    }

    const showStepper = activeStep > 0;
    const stepperActiveStep = activeStep > 0 ? activeStep - 1 : 0;

    return (
        <div>
            {showStepper && (
                <Box sx={{ mt: '3rem', maxWidth: '800px', mx: 'auto' }}>
                    <StepperNav activeStep={stepperActiveStep} onStepClick={handleStepClick} completedSteps={completedSteps} />
                </Box>
            )}
            <Container sx={{ marginTop: 2 }}>
                {content}
            </Container>
        </div>
    );
}